import { UserState } from '@coin/shared/auth/feature';

export const AppState = [UserState];
